export default "__VITE_ASSET__cbc914a4__"